import { Button } from "@/components/ui/button";
import { Check, Shield, Clock, TrendingUp } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useTranslation } from "react-i18next";
export function FinalCTASection() {
  const {
    t
  } = useTranslation();
  const {
    ref,
    isVisible
  } = useScrollReveal<HTMLDivElement>();
  const benefits = [{
    icon: Check,
    text: t("landing.finalCta.benefit1")
  }, {
    icon: Clock,
    text: t("landing.finalCta.benefit2")
  }, {
    icon: Shield,
    text: t("landing.finalCta.benefit3")
  }, {
    icon: TrendingUp,
    text: t("landing.finalCta.benefit4")
  }];
  return <section ref={ref} className="py-20 bg-gradient-to-br from-primary/20 via-primary/10 to-secondary/20 relative overflow-hidden">
      {/* Gradient Blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary/20 rounded-full blur-3xl animate-pulse" style={{
        animationDelay: "1s"
      }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className={`max-w-4xl mx-auto text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t("landing.finalCta.title")}
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            {t("landing.finalCta.subtitle")}
          </p>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 gap-4 mb-8 max-w-2xl mx-auto">
            {benefits.map((benefit, index) => <div key={index} className={`flex items-center gap-3 text-left transition-all duration-500 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`} style={{
            transitionDelay: `${index * 100 + 200}ms`
          }}>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                  <benefit.icon className="w-4 h-4 text-primary" />
                </div>
                <span className="text-sm font-medium">{benefit.text}</span>
              </div>)}
          </div>

          {/* CTA Buttons */}
          <div className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-700 delay-500 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
            <Button size="lg" className="text-lg px-8 py-6 hover-scale shadow-xl">
              {t("landing.finalCta.primaryCta")}
            </Button>
            
          </div>

          
        </div>
      </div>
    </section>;
}